'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'clapperboard-play';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e132';
var svgPathData = 'M325.8 208L48 208 48 384c0 26.5 21.5 48 48 48l154.9 0c1.9 5.4 4.1 10.8 6.5 16L96 448c-35.3 0-64-28.7-64-64l0-256c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 84c-5.1-3.7-10.5-7.2-16-10.3l0-73.7c0-16.4-8.3-31-20.9-39.6l-81.9 87.7c-8.2 .3-16.2 1.1-24.1 2.3l90.6-97C488 80.5 484 80 480 80l-124.6 0-104.9 112 104.7 0c-10.3 4.5-20.1 9.9-29.3 16zm-97.3-16l104.9-112-138 0-105 112 138.1 0zM96 80c-26.5 0-48 21.5-48 48l0 64 20.5 0 105-112-77.5 0zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-35.9 81c2.5-1.4 5.6-1.4 8.1 .1l93.3 56c2.4 1.4 3.9 4.1 3.9 6.9s-1.5 5.4-3.9 6.9l-93.3 56c-2.5 1.5-5.5 1.5-8.1 .1s-4.1-4.1-4.1-7l0-112c0-2.9 1.5-5.5 4.1-7zM408 409.9l69.8-41.9-69.8-41.9 0 83.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClapperboardPlay = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;